import BooleanComp from "./Boolean";
import NumberComp from "./Number";
import Sphere from "./Sphere";
import Line from "./Line";
import Point from "./Point";
import Box from "./Box";
import Circle from "./Circle";
import Move from "./Move";
import DivideCurve from "./DivideCurve";
import Addition from "./Addition";
import Surface from "./Surface";
import Extrusion from "./Extrusion";
import Rotate from "./Rotate";
import UnitVector from "./UnitVector";
import Area from "./Area";
import Loft from "./Loft";
import CustomPreview from "./CustomPreview";
import Material from "./Material";
import Panel from "./Panel";
import DeconstructBrep from "./DeconstructBrep";
import ListItem from "./ListItem";
import Polyline from "./Polyline";

export default [
  { ...NumberComp },
  { ...BooleanComp },
  { ...Point },
  { ...Line },
  { ...DivideCurve },
  { ...Circle },
  { ...Surface },
  { ...Sphere },
  { ...Box },
  { ...Move },
  { ...Extrusion },
  { ...Rotate },
  { ...UnitVector },
  { ...Area },
  { ...Addition },
  { ...Loft },
  { ...CustomPreview },
  { ...Material },
  { ...Panel },
  { ...DeconstructBrep },
  { ...ListItem },
  { ...Polyline },
];
